import { SwarovskiOptikSegmentKey } from "@swo/shared";
import { useStore } from "../store/hooks/use-store";
import { useFetched } from "../hooks";
import {
  GenericNotFoundPageLayout,
  NotFoundPageTranslations,
} from "../layouts/generic-not-found/GenericNotFoundPageLayout";
import { Navigate } from "react-router";
import React, { useEffect } from "react";
import { storefrontClient } from "../domain/storefront";
import { SwarovskiOptikSegmentShort } from "@swo/shared";
import { Maybe } from "../utils/fp/small-fp-utils";
import { ModalLoadingSpinner } from "./modal-loading-spinner";
import { SwagSlugBuilder } from "@swo/shared";
import { SwarovskiOptikLocaleFrontend } from "@swo/storefront";

function findSegmentForUser(
  localeSegments: Array<SwarovskiOptikSegmentShort>,
  userPreferredSegmentKey: Maybe<SwarovskiOptikSegmentKey>,
  fallbackSegmentKey: SwarovskiOptikSegmentKey,
) {
  const userPreferredSegment = userPreferredSegmentKey
    ? localeSegments.find(segment => segment.key === userPreferredSegmentKey)
    : undefined;

  const fallbackSegment = localeSegments.find(segment => segment.key === fallbackSegmentKey);

  return userPreferredSegment || fallbackSegment || localeSegments[0];
}

export function LocalizedFallbackRoute(props: {
  locale: SwarovskiOptikLocaleFrontend;
  notFoundPageTranslations: NotFoundPageTranslations;
}) {
  const store = useStore();

  const fallbacks = useFetched(() => storefrontClient.getSegments(props.locale.code), { dataKey: props.locale.code });

  useEffect(() => {
    if (!store.state.userPreferredSegmentKey && !store.state.showSegmentSelector) {
      store.dispatch({ type: "user-landed-in-non-localized-page" });
    }
  }, []);

  if (fallbacks.__tag !== "loaded") {
    return <ModalLoadingSpinner />;
  }

  const segment = findSegmentForUser(
    fallbacks.data.segments,
    store.state.userPreferredSegmentKey,
    fallbacks.data.fallbackSegmentKey,
  );
  if (!segment) {
    return <GenericNotFoundPageLayout translations={props.notFoundPageTranslations} />;
  }

  return <Navigate to={SwagSlugBuilder.segmentPathObj(props.locale, segment)} />;
}
